module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/phone-993fff0479de6ffd9b0d14263835beb5.png";